<template>
	<div class="leftres">
		<div>
			<div :class=" showorhide ? 'inputtop' : 'inputtops' ">
				<div v-for="(item , index) of formdata" :key="index" style="display: inline-block;">
					<Commondropdownlist ref="despatchRef" :options="item.options" :lablewith="item.lablewith"
						:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width" :event="item.event" @invClass="handleInvClassChange"></Commondropdownlist>
				</div>
				<div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
					<CommonBtngroup :show="showorhide" @showclick="showclick" @hide="hide" @select="select"
						@reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;">
				</div>
			</div>
			<div class="TableBox"
				style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<PurchaseAveragePricetable :tableData="tableData" :total="total" @Export="Export" @ExportList="ExportList"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
				</PurchaseAveragePricetable>
			</div>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from '../../../components/common-dropdownlist.vue'
	import CommonBtngroup from '../../../components/commongroup.vue'
	import PurchaseAveragePricetable from './components/PurchaseAveragePricetable.vue'
	import utils from '../../../common/utils'
	import {
		PurchaseAveragePriceList,
		PurchaseAveragePriceExport,
		PurchaseAveragePriceListExport,
		InventoryClassList
	} from '@/api/home'
	import {
		GetLevel2List,
		GetLevel3List
	} from '@/api/newsapi'

	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			PurchaseAveragePricetable,
		},
		data() {
			return {
				total: 1,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				showorhide: true,
				formdata: [
					{
						inputdata: "",
						title: "年份",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请选择",
						types: "",
						inputtype: "datey",
						width: "140px",
						lablewith: "80px"
					},
					{
						inputdata: '',
						title: '经销商',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '产品线',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'selectMultiple',
						width: '200px',
						options: [],
						lablewith: '100px',
						event: 'invClass'
					},
					{
						inputdata: '',
						title: 'LEVEL2',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'selectMultiple',
						width: '200px',
						options: [],
						lablewith: '80px'
					},
					{
						inputdata: '',
						title: 'LEVEL3',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'selectMultiple',
						width: '200px',
						options: [],
						lablewith: '80px'
					},
					{
						inputdata: '',
						title: '周期',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'selectMultiple',
						width: '200px',
						options: [
							{ key: 'Q1', value: 'Q1' },
							{ key: 'Q2', value: 'Q2' },
							{ key: 'Q3', value: 'Q3' },
							{ key: 'Q4', value: 'Q4' },
							{ key: 'H1', value: 'H1' },
							{ key: 'H2', value: 'H2' }
						],
						lablewith: '80px'
					},
					{
						inputdata: '',
						title: '价格区间',
						fontSize: '14px',
						color: '#333333',
						placeholder: '最低价',
						types: 'number',
						inputtype: 'input',
						width: '100px',
						lablewith: '80px'
					},
					{
						inputdata: '',
						title: '至',
						fontSize: '14px',
						color: '#333333',
						placeholder: '最高价',
						types: 'number',
						inputtype: 'input',
						width: '100px',
						lablewith: '40px'
					}
				],
				from: {
					Year: "",
					CusName: "",
					InvClass: "",
					Level2Code: "",
					Level3Code: "",
					Quarter: "",
					AverPrice1: "",
					AverPrice2: ""
				}
			}
		},
		mounted() {
			this.from.Year = new Date().getFullYear().toString();
			this.$refs.despatchRef[0].modelvalue = this.from.Year;
			this.inventoryClassList()
			
			// 自动调用一次查询接口以确保初始带年份请求
			this.getList()
		},
		methods: {
			// 获取产品线下拉
			async inventoryClassList() {
				let { code, data } = await InventoryClassList({})
				if (code == 0) {
					try {
						this.formdata[2].options = []
						data.data.map((item, index) => {
							let obj = {
								key: item.InvClass,
								value: item.InvClassName
							}
							this.formdata[2].options.push(obj)
						})
					} catch (error) {}
				}
			},
			handleInvClassChange(val) {
				let invClassVal = val.modelvalue ? val.modelvalue.join(',') : '';
				
				// Clear L2 and L3
				this.$refs.despatchRef[3].modelvalue = [];
				this.$refs.despatchRef[4].modelvalue = [];
				this.formdata[3].options = [];
				this.formdata[4].options = [];
				
				if (!invClassVal) return;
				
				this.getLevel2List(invClassVal);
				this.getLevel3List(invClassVal);
			},
			async getLevel2List(invClass) {
				let { code, data } = await GetLevel2List({ InvClass: invClass });
				if (code == 0) {
					this.formdata[3].options = data.map(item => ({
						key: item.Value,
						value: item.Text
					}));
				}
			},
			async getLevel3List(invClass) {
				let { code, data } = await GetLevel3List({ InvClass: invClass });
				if (code == 0) {
					this.formdata[4].options = data.map(item => ({
						key: item.Value,
						value: item.Text
					}));
				}
			},
			// 列表
			async getList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				let { data, code, message } = await PurchaseAveragePriceList({
					Year: this.from.Year,
					CusName: this.from.CusName,
					InvClass: this.from.InvClass,
					Level2Code: this.from.Level2Code,
					Level3Code: this.from.Level3Code,
					Quarter: this.from.Quarter,
					AverPrice1: this.from.AverPrice1,
					AverPrice2: this.from.AverPrice2,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (code == 0) {
					this.total = data.Count || data.Total || 0;
					this.tableData = data.data || data.Data || data || [];
				} else {
					this.$message.warning(message)
				}
				loading.close();
			},
			// 导出
			async exportData() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出（横版）...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await PurchaseAveragePriceExport({
					Year: this.from.Year,
					CusName: this.from.CusName,
					InvClass: this.from.InvClass,
					Level2Code: this.from.Level2Code,
					Level3Code: this.from.Level3Code,
					Quarter: this.from.Quarter,
					AverPrice1: this.from.AverPrice1,
					AverPrice2: this.from.AverPrice2,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `采购均价报表（横版）${str}`, "xlsx")
					loading.close();
				} else {
					this.$message.warning('导出失败');
					loading.close();
				}
				loading.close()
			},
			async exportListData() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出（列表）...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await PurchaseAveragePriceListExport({
					Year: this.from.Year,
					CusName: this.from.CusName,
					InvClass: this.from.InvClass,
					Level2Code: this.from.Level2Code,
					Level3Code: this.from.Level3Code,
					Quarter: this.from.Quarter,
					AverPrice1: this.from.AverPrice1,
					AverPrice2: this.from.AverPrice2,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `采购均价报表（列表）${str}`, "xlsx")
					loading.close();
				} else {
					this.$message.warning('导出失败');
					loading.close();
				}
				loading.close()
			},
			Export() {
				this.exportData()
			},
			ExportList() {
				this.exportListData()
			},
			// 清空
			reset() {
				this.$refs.despatchRef.map((item, index) => {
					item.modelvalue = ''
				})
				this.formdata[3].options = [];
				this.formdata[4].options = [];
				
				// 重置后年份默认当年
				this.from.Year = new Date().getFullYear().toString();
				this.$refs.despatchRef[0].modelvalue = this.from.Year;
				this.from.AverPrice1 = "";
				this.from.AverPrice2 = "";
				this.from.Quarter = "";
			},
			hide() {
				this.showorhide = false
			},
			showclick() {
				this.showorhide = true
			},
			select() {
				this.pageindex = 1
				try {
					this.from.Year = this.$refs.despatchRef[0].modelvalue
					this.from.CusName = this.$refs.despatchRef[1].modelvalue
					this.from.InvClass = this.$refs.despatchRef[2].modelvalue ? this.$refs.despatchRef[2].modelvalue.join(',') : ''
					this.from.Level2Code = this.$refs.despatchRef[3].modelvalue ? this.$refs.despatchRef[3].modelvalue.join(',') : ''
					this.from.Level3Code = this.$refs.despatchRef[4].modelvalue ? this.$refs.despatchRef[4].modelvalue.join(',') : ''
					this.from.Quarter = this.$refs.despatchRef[5].modelvalue ? this.$refs.despatchRef[5].modelvalue.join(',') : ''
					this.from.AverPrice1 = this.$refs.despatchRef[6].modelvalue
					this.from.AverPrice2 = this.$refs.despatchRef[7].modelvalue
					this.getList()
				} catch (error) {
					this.getList()
				}
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex
				this.getList()
			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie
				this.getList()
			},
		}
	}
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: 60px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		transition: all 0.3s;
		overflow: hidden;
	}

	.inputtops {
		width: 980px;
		height: 0px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		padding-bottom: 64px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 10px;
		width: 400px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 45px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 0px;
	}
</style>
